import { render, staticRenderFns } from "./EcosystemForm.vue?vue&type=template&id=f541ba24"
import script from "./EcosystemForm.vue?vue&type=script&lang=js"
export * from "./EcosystemForm.vue?vue&type=script&lang=js"
import style0 from "./EcosystemForm.vue?vue&type=style&index=0&id=f541ba24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports